import { MicrobiologyStorage } from './../../on-screen-results/microbiology-data/microbiology-storage';
import { Injectable } from '@angular/core';
import { MicrobiologyDataStorage } from '../../on-screen-results/microbiology-data/microbiology-data-storage';
import { SiteRouteDataStorage } from '../site-route-data-storage';
import { Observable } from 'rxjs';
import { MicrobiologyData } from '../../on-screen-results/microbiology-data/microbiology-data';
import { map } from 'rxjs/operators';

@Injectable()
export class InvestigatorMicrobiologyStorage implements MicrobiologyDataStorage {
    constructor(private selectedSiteRouteData: SiteRouteDataStorage, private storage: MicrobiologyStorage) {

    }

    public get siteMicrobiologyData(): Observable<MicrobiologyData[]> {
        return this.storage.getMicrobiologyForSite(
            this.selectedSiteRouteData.selectedSite.pipe(map(s => s.siteId)));
    }
}